import z from 'zod';

export const createActivitySchema = z.object({
  title: z
    .string({ message: 'O nome da atividade é obrigatório' })
    .max(255, 'O nome da atividade deve ter no máximo 255 caracteres')
    .min(1, 'O nome da atividade é obrigatório'),
  description: z.string({ message: 'A descrição é obrigatória' }).optional(),
  resource_url: z.string().optional(),
});

export type ActivityResponseType = z.infer<typeof createActivitySchema>;
